import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useGetAuthStatusQuery } from './authApi';
import { useIsSignedIn } from './userApi';
import { IRootState } from '../state/rootReducer';
import { redirectToReAuthentication } from './startReAuthentication';
import userFlowSlice from '@features/userFlow/userFlowSlice';
import { navigateWindow } from '../utils';

export function useAuthStatusRedirect() {
    const isSignedIn = useIsSignedIn();
    const { data: authStatus } = useGetAuthStatusQuery({}, { skip: !isSignedIn });
    const signInState = useSelector((state: IRootState) => state.userFlow.signInState);
    const dispatch = useDispatch();

    useEffect(() => {
        if (!isSignedIn || !authStatus) {
            return;
        }

        if (authStatus.should_re_authenticate && authStatus.authorization_url) {
            try {
                redirectToReAuthentication(authStatus.authorization_url, signInState?.isPopup);
            } catch (error) {
                console.error('Error handling auth status:', error);
            }
            return;
        }

        if (signInState?.isPopup) {
            dispatch(userFlowSlice.actions.setSignInState({ signInState: null }));
            window.close();
            navigateWindow(signInState.redirectTo || '/');
        }
    }, [isSignedIn, authStatus, signInState, dispatch]);
}
